//CRN_20260508 - Riskline Specific Traveller Advice service (PUSH side - reads from SureSim backend)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, Observable, of, throwError } from 'rxjs';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';
import { SpecificTravellerAdviceDTO } from '../../models/system/riskline/riskline-sta.dto';

@Injectable({ providedIn: 'root' })
export class RisklineStaService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getAllStas(): Observable<SpecificTravellerAdviceDTO[]> {
    try {
      return this.httpClientService
             .get<SpecificTravellerAdviceDTO[]>(environment.eSimApi +
                                                eSimApiPaths.RiskIntelligence + '/' +
                                                eSimApiPaths.RiskIntelligenceSta)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineStaService.getAllStas() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of([]);
    }
  }

  public getStaForCountry(isoCode: string): Observable<SpecificTravellerAdviceDTO> {
    try {
      if (!isoCode || isoCode.trim()=='')
        throw new Error('RisklineStaService.getStaForCountry() - isoCode is required');

      return this.httpClientService
             .get<SpecificTravellerAdviceDTO>(environment.eSimApi +
                                              eSimApiPaths.RiskIntelligence + '/' +
                                              eSimApiPaths.RiskIntelligenceSta + '/' +
                                              isoCode)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineStaService.getStaForCountry() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
